module.exports = __webpack_public_path__ + "assets/img/title-9b4e3ca4.png";